<!-- gwtg -->
<template>
  <div class="uploadCAD" style="overflow-y: scroll; height: 100%">
    <div class="title">
      <i></i>
      <b></b>
      上传说明
    </div>
    <div class="explain">
      <p>说明：</p>
      <p>1.觅图会员发布CAD户型图，采取5:5分成方式。</p>
      <p>
        2.图片尺寸<span class="border">宽度 < 2400像素</span>，<span
          class="border"
          >高度 < 1920像素</span
        >。
      </p>
      <p>
        3. 图片可以上传多张，相对应的模型只能上传一个,<span class="border"
          >模型要添加压缩上传</span
        >，支持格式有rar、zip、7z等，大小不能超过30M。
      </p>
      <p>
        4.
        第一张图片是模型的封面，一定要漂亮哦；名称默认是读取附件的名称，您也可以手动修改并注明版本信息。
      </p>
      <p>
        5. 图片支持格式有jpg、png、gif等，其中gif不含动画格式，最多不超过5张。
      </p>
      <p>
        6.
        该模型的意向价格可定为（0-30元），也可以不填写，最终的价格由觅图网决定。
      </p>
      <p>7. 觅图网鼓励设计师上传高品质原创CAD户型图。</p>
      <p>
        8.
        赚取的现金满100元即可提现，每个月1～5号提交审核，25-31号转款到支付宝账户。
      </p>
    </div>
    <div>
      <el-table
        :data="tableData"
        v-loading="loading"
        class="v-t-table"
        element-loading-text="素材上传中..."
        border
        style="width: 100%"
      >
        <el-table-column
          label="小区名称"
          header-align="center"
          width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.name"
              size="mini"
              placeholder="请输入小区/栋号/楼号"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="封面"
          header-align="center"
          align="center"
          width="100px"
        >
          <template slot-scope="scope">
            <el-upload
              class="upload-demo6"
              :class="{
                styleA: fileList.length === 0,
                styleB: fileList.length === limit,
              }"
              ref="uploadCAD"
              action
              accept=".jpeg,.png,.jpg,.bmp,.gif"
              list-type="picture-card"
              :show-file-list="true"
              :file-list="fileList"
              :limit="limit"
              :http-request="
                (file) => {
                  return importData(file, scope.$index, scope.row);
                }
              "
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column
          prop="fileList1"
          label="图片（最多上传4张）"
          header-align="center"
          width="400px"
        >
          <template slot-scope="scope">
            <el-upload
              class="upload-demo6"
              :class="{
                styleC: fileList1.length != limit1,
                styleD: fileList1.length === limit1,
                'upload-demo1': fileList1.length > 0,
              }"
              ref="uploadCAD1"
              action
              accept=".jpeg,.png,.jpg,.bmp,.gif"
              list-type="picture-card"
              size="mini"
              :show-file-list="true"
              :limit="limit1"
              :file-list="scope.row.fileList1"
              :on-remove="handleRemove1"
              :http-request="
                (file) => {
                  return importData1(file, scope.$index, scope.row);
                }
              "
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column label="素材附件" width="150px" header-align="center">
          <template slot-scope="scope">
            <el-upload
              class="upload-demo6"
              accept=".zip,.jar,.7z,.rar"
              ref="uploadCAD2"
              v-if="!scope.row.rarName"
              action
              list-type="picture-card"
              :show-file-list="false"
              :limit="limit2"
              :on-remove="handleRemove2()"
              :http-request="importData2"
            >
              <i class="el-icon-plus"></i>
              <template> </template>
            </el-upload>
            <div v-if="scope.row.rarName" class="flex align-items-center">
              <div class="mr-1">{{ scope.row.rarName }}</div>
              <div class="el-icon-close" @click="handleRemove2"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="户型图所属省"
          width="150px"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.provinceCode"
              clearable
              placeholder="请选择所在省"
              @change="provinceChange"
            >
              <el-option
                v-for="item in provinceData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="户型图所属市"
          width="150px"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              class="ml-1"
              v-model="scope.row.cityCode"
              clearable
              placeholder="请选择所在市或地区"
              @change="cityChange"
            >
              <el-option
                v-for="item in cityData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="地址信息"
          header-align="center"
          width="180px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.housing"
              size="mini"
              placeholder="请输入小区/栋号/楼号"
            ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column
          label="金额（元）"
          header-align="center"
          width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.price"
              size="mini"
              placeholder="金额"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">
            <div class="d-flex flex-column align-items-center">
              <el-button
                @click="handleClick(scope.row)"
                type="primary"
                plain
                size="small"
                style="width: 80px"
                >上传</el-button
              >
              <!-- <el-button
                type="danger"
                plain
                size="small"
                style="marginTop:3px;width:80px"
                >删除</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { apiBaseImgUrl } from "@/server/api";
export default {
  data() {
    return {
      searchParams: {},
      fileList: [],
      fileList1: [],
      limit: 1,
      limit2: 1,
      limit1: 4,
      loading: false,
      defaultSearchParams: {},
      tableData: [
        {
          name: "",
          file: "",
          fengmianName: "",
          price: "",
          housing: "",
          fileList1: [],
          fileRarUrl: "",
          rarName: "",
          materialSize: "",
          provinceCode: "440000",
          cityCode: "440300",
          provinceName: "广东省",
          cityName: "深圳市",
        },
      ],
      cityData: [],
      provinceData: [],
    };
  },
  components: {},
  created() {},
  mounted() {
    this.getProvince();
    this.provinceChange();
  },
  methods: {
    handleClick(row) {
      if (this.tableData[0].file == "") {
        this.$message.warning("请上传封面图");
        return;
      }
      if (this.tableData[0].rarName == "") {
        this.$message.warning("请上传素材附件");
        return;
      }
      const p = {
        materialUrl: row.fileRarUrl,
        materialName: row.rarName,
        type: 1,
        price: row.price,
        name: row.name,
        housing: row.housing,
        fengmianName: row.fengmianName,
        fengmianUrl: row.file,
        imageUrlList: this.fileList1,
        materialSize: row.materialSize,
        provinceCode: row.provinceCode,
        cityCode: row.cityCode,
        provinceName: this.tableData[0].provinceName,
        // provinceName: row.provinceName,
        cityName: this.tableData[0].cityName,
        // cityName: row.cityName,
      };
      this.$post("materialCenter/insertOrUpdate", p).then((res) => {
        this.$message.success("素材上传成功");
        this.tableData[0].name = "";
        this.tableData[0].fileList1 = [];
        this.tableData[0].fengmianName = "";
        this.tableData[0].file = "";
        this.tableData[0].fileRarUrl = "";
        this.tableData[0].price = "";
        this.tableData[0].rarName = "";
        this.tableData[0].housing = "";
        this.tableData[0].materialSize = "";
        // this.tableData[0].provinceName = "";
        // this.tableData[0].cityCode = "";
        // this.tableData[0].cityName = "";
        // this.tableData[0].provinceCode = "";
        this.fileList1 = [];
        this.fileList = [];
      });
    },
    handleRemove() {
      this.fileList = [];
      this.tableData[0].file = "";
    },
    //获取省份
    getProvince() {
      this.$get("location/getAreaProvinceList").then((res) => {
        this.provinceData = res.data;
      });
    },
    //省份改变查市
    provinceChange() {
      if (this.tableData[0].provinceCode) {
        this.$get("location/getAreaByParentIdList", {
          parentId: this.tableData[0].provinceCode,
        }).then((res) => {
          this.cityData = res.data;
          let areaName = this.provinceData.find(
            (item) => item.id === this.tableData[0].provinceCode
          );
          this.tableData[0].provinceName = areaName.name;
        });
      } else {
        this.tableData[0].cityCode = "";
        this.$message.warning("请先选择所在省");
        return;
      }
    },
    cityChange() {
      if (this.tableData[0].cityCode) {
        let cityName = this.cityData.find(
          (item) => item.id === this.tableData[0].cityCode
        );
        this.tableData[0].cityName = cityName.name;
      }
    },
    handleRemove1(file, fileList) {
      let fileUrl = file.url.slice(25);

      this.tableData[0].fileList1.map((item) => {
        if (item.url == file.url) {
          this.tableData[0].fileList1.splice(item, 1);
        }
      });

      this.fileList1.map((item) => {
        if (item == fileUrl) {
          this.fileList1.splice(item, 1);
        }
      });
    },
    handleRemove2() {
      this.tableData[0].rarName = "";
      this.tableData[0].materialSize = "";
      this.tableData[0].fileRarUrl = "";
    },
    async importData(content) {
      const fileName = content.file.name;
      const fileType = fileName.substring(fileName.lastIndexOf("."));
      if (
        fileType === ".jpg" ||
        fileType === ".png" ||
        fileType === ".jpeg" ||
        fileType === ".bmp" ||
        fileType === ".gif"
      ) {
      } else {
        this.$message.error("请上传正确的图片类型");
        this.tableData[0].file = "";
        return false;
      }
      let param = new FormData();
      param.append("file", content.file);
      this.loading = true;
      this.$post("file/upload", param, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        this.loading = false;
        this.fileList.push({
          url: `${apiBaseImgUrl}${res.data.filePath}`,
        });
        this.tableData[0].file = res.data.filePath;
        this.tableData[0].fengmianName = res.data.fileName;
        this.$message.success("图片上传成功");
      });
    },

    async importData1(content, index, row) {
      this.loading = true;
      let param = new FormData();
      param.append("file", content.file);
      this.$post("file/upload", param, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        this.tableData[0].fileList1.push({
          fileName: res.data.fileName,
          url: `${apiBaseImgUrl}${res.data.filePath}`,
        });
        this.loading = false;
        this.fileList1.push(res.data.filePath);
        this.$message.success("图片上传成功");
      });
    },
    async importData2(content, row) {
      // console.log(content);
      let imgSize = Number(content.file.size / 1024 / 1024);
      if (imgSize > 30) {
        this.$message.error("文件大小不能超过20MB，请重新上传。");
        return;
      }
      let param = new FormData();
      param.append("file", content.file);
      this.loading = true;
      this.$post("file/upload", param, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.tableData[0].materialSize = `${imgSize.toFixed(2).toString()}`;
          this.tableData[0].rarName = res.data.fileName;
          this.tableData[0].fileRarUrl = `${res.data.filePath}`;
          this.$message.success("附件上传成功");
          this.loading = false;
          if (!this.tableData[0].name) {
            this.tableData[0].name = res.data.fileName.substring(
              0,
              res.data.fileName.length - 4
            );
          }
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error("附件上传失败");
        });
    },
    reset() {
      this.searchParams = Object.assign({}, this.defaultSearchParams);
    },
  },
  destroyed() {
    this.tableData[0].provinceName = "";
    this.tableData[0].cityCode = "";
    this.tableData[0].cityName = "";
    this.tableData[0].provinceCode = "";
  },
  computed: {},
};
</script>
<style lang="less" scoped>
.explain {
  padding: 20px;
}
.v-t-table {
  // height: 500px;
}
.explain > p {
  margin-top: 8px;
  font-size: 16px;
  margin-left: 8px;
}
.explain > p > span {
  font-size: 18px;
  padding: 3px;
}
.explain > p:first-child {
  margin-top: 0px;
  margin-left: 0;
  font-size: 20px;
}
.uploadCAD {
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 10px;
  overflow-y: scroll;
  .title {
    display: flex;
    font-size: 22px;
    padding: 0 10px;
    align-items: center;
    line-height: 50px;
    color: #5c80d9;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    i {
      display: block;
      height: 20px;
      margin-right: 1px;
      border-left: 1px solid #5c80d9;
    }
    b {
      display: block;
      height: 20px;
      margin-right: 8px;
      border-left: 2.5px solid #5c80d9;
    }
    .qhtb {
      display: flex;
      justify-content: center;
      margin-left: 600px;
    }
    .xz {
      display: flex;
      justify-content: center;
      margin-left: auto;
    }
  }
  .s-p {
    display: flex;
    height: 60px;
    line-height: 60px;
    align-items: center;
    flex-direction: flex-start;
    padding: 0 10px;
    border-top: 1px solid #e5e5e5;
    > * {
      margin-right: 10px;
    }
  }
  .c-p {
    padding: 12px 10px;
    width: 100%;
    height: calc(100% - 110px);
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    .box-card {
      width: 373px;
      height: 208px;
    }
  }
}
.p-p {
  display: flex;
  height: 50px;
  justify-content: center;
  // margin-left: 530px;
  align-items: center;
  text-align: center;
}

#mapDisplay {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
<style lang="less">
.upload-demo6 {
  .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 120px;
  }
}

.styleB .el-upload--picture-card {
  display: none;
}

.styleD .el-upload--picture-card {
  display: none;
}
.styleC .el-upload--picture-card {
  display: "";
}

.styleF .el-upload--picture-card {
  display: none;
}
// .el-upload--picture-card {
//   width: 150px;
//   height: 150px;
// }
.el-upload-list__item {
  transition: none;
}
.el-upload-list__item-thumbnail {
  object-fit: scale-down !important;
}
.upload-demo1 {
  height: 140px;
  .el-upload .el-upload--picture-card {
    height: 125px;
  }
  .avatar-uploader .el-upload {
    width: 140px;
    height: 140px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 140px;
    height: 140px;
  }
}
.upload-demo {
  // width: 150px;

  .el-upload .el-upload--picture-card {
    height: 125px;
  }
  .avatar-uploader .el-upload {
    width: 100px;
    height: 100px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}
</style>
